import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api, setToken } from "../lib/api";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const run = async () => {
      const hash = window.location.hash || "";
      const m = hash.match(/session_id=([^&]+)/);
      if (!m) {
        navigate("/login");
        return;
      }
      const sessionId = m[1];
      try {
        const res = await api.post("/auth/session", { session_id: sessionId });
        // Store token in localStorage for mobile cookie fallback (iOS Safari ITP)
        if (res.data.session_token) setToken(res.data.session_token);
        // Clean URL
        window.history.replaceState(null, "", "/dashboard");
        navigate("/dashboard", { state: { user: res.data.user } });
      } catch (e) {
        navigate("/login");
      }
    };
    run();
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FDFDFD]">
      <div className="text-center">
        <div className="w-10 h-10 border-2 border-zinc-300 border-t-zinc-950 rounded-full animate-spin mx-auto"></div>
        <p className="mt-4 text-sm text-zinc-600 label-eyebrow">Establishing session</p>
      </div>
    </div>
  );
}
